(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3986],{

/***/ 79114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/routes/template/queries/index.ts + 21 modules
var queries = __webpack_require__(64896);
// EXTERNAL MODULE: ./src/views/Template/ContentDownloadPage/components/ContentDownload.tsx + 4 modules
var ContentDownload = __webpack_require__(46524);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/ContentDownloadPage.tsx




var ContentDownloadPageView = function ContentDownloadPageView(_ref) {
  var slug = _ref.slug;

  var _useSingleContentDown = (0,queries/* useSingleContentDownloadPageQuery */.c4)({
    args: [slug]
  }),
      data = _useSingleContentDown.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentDownload/* default */.Z, {
    data: data
  });
};

/* harmony default export */ var ContentDownloadPage = (ContentDownloadPageView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/learn-segment-content-download/[slug].tsx





var Page = function Page(_ref) {
  var slug = _ref.slug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentDownloadPage, {
      slug: slug
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (Page);

/***/ }),

/***/ 58265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn-segment-content-download/[slug]",
      function () {
        return __webpack_require__(79114);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,1784,6234,4136,2073,6784,8392,5735,2429,2609,948,3996,7947,7960,6012,442,9524,4120,2557,9774,2888,179], function() { return __webpack_exec__(58265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);